import React, { FC } from 'react'

export enum IconName {
  'arrowdown' = 'arrowdown',
  'arrowleft' = 'arrowleft',
  'arrowright' = 'arrowright',
  'arrowup' = 'arrowup',
  'barchart' = 'barchart',
  'belly' = 'belly',
  'biceps' = 'biceps',
  'bmi' = 'bmi',
  'bookmark' = 'bookmark',
  'bookmarkfilled' = 'bookmarkfilled',
  'calendar' = 'calendar',
  'camera' = 'camera',
  'check' = 'check',
  'clock' = 'clock',
  'cog' = 'cog',
  'close' = 'close',
  'construction' = 'construction',
  'book' = 'book',
  'copy' = 'copy',
  'cupcake' = 'cupcake',
  'piechart' = 'piechart',
  'edit' = 'edit',
  'fire' = 'fire',
  'goal' = 'goal',
  'glass' = 'glass',
  'heart' = 'heart',
  'heartfilled' = 'heartfilled',
  'loadingspinner' = 'loadingspinner',
  'mail' = 'mail',
  'menuh' = 'menuh',
  'menuv' = 'menuv',
  'minus' = 'minus',
  'move' = 'move',
  'password' = 'password',
  'plus' = 'plus',
  'print' = 'print',
  'profilepicture' = 'profilepicture',
  'refresh' = 'refresh',
  'replace' = 'replace',
  'scale' = 'scale',
  'search' = 'search',
  'socialfacebook' = 'socialfacebook',
  'socialinstagram' = 'socialinstagram',
  'socialyoutube' = 'socialyoutube',
  'tapeline' = 'tapeline',
  'timer' = 'timer',
  'trash' = 'trash',
  'users' = 'users',
  'utensils' = 'utensils',
  'waterempty' = 'waterempty',
  'wateremptyplus' = 'wateremptyplus',
  'waterfull' = 'waterfull',
  'watch' = 'watch',
  'weight' = 'weight'
}

export enum IconColor {
  GRAY_1 = 'gray-1',
  GRAY_2 = 'gray-2',
  BLUE_2 = 'blue-2',
  WHITE = 'white',
  GREEN = 'green'
}

interface Props {
  name: IconName
  color?: string
  hiddenInPrint?: boolean
  large?: boolean
  medium?: boolean
  style?: React.CSSProperties
  ariaHidden?: boolean
}

export const Icon: FC<Props> = ({
  name,
  color = IconColor.GRAY_1,
  hiddenInPrint,
  large,
  medium,
  style,
  ariaHidden
}: Props) => {
  const getIconClassSuffix = (): string => {
    if (large) {
      return '-large'
    }

    if (medium) {
      return '-medium'
    }

    return ''
  }

  const iconClassSuffix = getIconClassSuffix()

  return (
    <div
      aria-label={name}
      aria-hidden={ariaHidden}
      className={`icon${iconClassSuffix} icon-${name}-${color} ${hiddenInPrint && 'hiddenInPrint'}`}
      style={style}
    ></div>
  )
}
